import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import noResultsImg from '@/shared/assets/images/no-results.png';
import { cn } from '@/shared/utils/cn';

/**
 * PLP "no designs found" state.
 */
export function PlpNoResults({ compact = false }: { compact?: boolean }) {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 text-center transition-opacity duration-200',
        compact ? 'flex-1 py-12' : 'min-h-[calc(100vh-56px-56px)]',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
    >
      <img
        src={noResultsImg}
        alt="No designs found"
        className="mb-6 h-40 w-auto max-w-full"
      />
      <h2 className="mb-2 text-lg font-semibold text-gray-900">
        Oops! No designs found.
      </h2>
      <p className="mb-6 max-w-sm text-sm text-gray-600">
        We will try our best to add the designs that you are looking for.
      </p>
      <button
        type="button"
        className="text-sm font-semibold uppercase tracking-wide text-[#2B5DA9]"
        onClick={() => navigate('/jewellery.html')}
      >
        BACK TO BROWSING
      </button>
    </div>
  );
}

